import React, { useState } from 'react';
import { TextInput, required, useDataProvider, useRefresh } from 'react-admin';
import { ActionButton, BaseForm } from '../../Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { CircularProgress } from '@material-ui/core';
import { appStyles } from '../../styles';

const SleuthForm = (props) => {
  const { record } = props;
  const dataProvider = useDataProvider();
  const classes = appStyles();
  const [loading, setLoading] = useState(false);
  const refresh = useRefresh();

  const handleAwardButton = () => {
    setLoading(true);
    dataProvider('UPDATE', 'eventSuperSleuth', { id: record.id })
      .then(() => {
        setLoading(false);
        refresh();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <BaseForm showToolbar={false} {...props}>
      <TextInput source="sleuthName" validate={required()} disabled />
      <TextInput source="suspectName" validate={required()} disabled />
      <TextInput source="evidence" multiline validate={required()} disabled />
      {props.record.isSuperSleuth === 'No' ? (
        loading ? (
          <CircularProgress size={20} className={classes.circularProgress} />
        ) : (
          <ActionButton
            label="Award"
            onClick={handleAwardButton}
            style={{ backgroundColor: 'green' }}
            icon={<FontAwesomeIcon icon={faStar} />}
          />
        )
      ) : null}
    </BaseForm>
  );
};

export default SleuthForm;
